export default "__VITE_ASSET__628c689d__"